export default __webpack_public_path__ + "static/media/job_offer18_s.98c5e445.jpg";